export default class ComplaintModel {
    constructor ({ id, name, name_company, email, phone, subject, description, proof, status, created_on }){
        this.id = id;
        this.name_complainer = name;
        this.name_company = name_company;
        this.email = email;
        this.no_hp = phone;
        this.subject = subject;
        this.deskripsi = description;
        this.bukti = proof;
        this.status = status;
        this.created_on = created_on;
    }
}